import { render, staticRenderFns } from "./AddDevolutiva.vue?vue&type=template&id=6e588bad"
import script from "./AddDevolutiva.vue?vue&type=script&lang=js"
export * from "./AddDevolutiva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports